import { render, staticRenderFns } from "./_base-alert.vue?vue&type=template&id=296bc79f&"
import script from "./_base-alert.vue?vue&type=script&lang=js&"
export * from "./_base-alert.vue?vue&type=script&lang=js&"
import style0 from "./_base-alert.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296bc79f')) {
      api.createRecord('296bc79f', component.options)
    } else {
      api.reload('296bc79f', component.options)
    }
    module.hot.accept("./_base-alert.vue?vue&type=template&id=296bc79f&", function () {
      api.rerender('296bc79f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-alert.vue"
export default component.exports